import { IInputMultiSelectFiltersMeta } from 'Mri.Web.Common';
import * as React from 'react';
import { BsColumnsGap } from '@react-icons/all-files/bs/BsColumnsGap';
import { BsBuilding } from '@react-icons/all-files/bs/BsBuilding';
import { BsMap } from '@react-icons/all-files/bs/BsMap';
import { BsFileEarmarkDiff } from '@react-icons/all-files/bs/BsFileEarmarkDiff';
import { AccountsFilter } from './AccountsFilter';
import { CitiesFilter } from './CitiesFilter';
import { ContractsFilter } from './ContractsFilter';
import { CountriesFilter } from './CountriesFilter';
import { DisplayListViewModel } from './DisplayListViewModel';
import { PartDefinitionsFilter } from './PartDefinitionsFilter';
import { StateOrProvincesFilter } from './StateOrProvincesFilter';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';
import { BsPeople } from '@react-icons/all-files/bs/BsPeople';

export const displayFilters: readonly IInputMultiSelectFiltersMeta<DisplayListViewModel>[] = [
    {
        id: 'accounts',
        title: 'Accounts',
        icon: <BsBuilding style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.accounts != undefined,
        render: props => <AccountsFilter key="accounts" {...props} />,
    },
    {
        id: 'contracts',
        title: 'Contracts',
        icon: <BsFileEarmark style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.contracts != undefined,
        render: props => <ContractsFilter key="contracts" {...props} />,
    },
    {
        id: 'partDefinitions',
        title: 'Part Numbers',
        icon: <BsFileEarmarkDiff style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.partDefinitions != undefined,
        render: props => <PartDefinitionsFilter key="partDefinitions" {...props} />,
    },
    {
        id: 'cities',
        title: 'Cities',
        icon: <BsPeople style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.cities != undefined,
        render: props => <CitiesFilter key="cities" {...props} />,
    },
    {
        id: 'stateOrProvince',
        title: 'State Or Province',
        icon: <BsMap style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.stateOrProvinces != undefined,
        render: props => <StateOrProvincesFilter key="stateOrProvince" {...props} />,
    },
    {
        id: 'countries',
        title: 'Countries',
        icon: <BsColumnsGap style={{ fontSize: 18 }} />,
        shouldRender: vm => vm.displayFilter.countries != undefined,
        render: props => <CountriesFilter key="countries" {...props} />,
    },
];
